import { RouteConfig } from 'vue-router'
import AdminLayout from '@/views/layouts/AdminLayout.vue'
import Dashboard from '@/views/admin/Dashboard.vue'
import SearchBase from '@/views/admin/search/index.vue'
import Search from '@/views/admin/search/Search.vue'
import SearchResults from '@/views/admin/search/SearchResults.vue'
import Favorites from '@/views/admin/Favorites.vue'
import JobStats from '@/views/admin/JobStats.vue'
import Users from '@/views/admin/Users.vue'
import Assessments from '@/views/admin/Assessments.vue'
import Reports from '@/views/admin/Reports.vue'
import Courses from '@/views/admin/Courses.vue'
import { ROLES } from '@/store'

export default {
  path: '/admin',
  component: AdminLayout,
  meta: {
    requiresAuth: true,
    allowedRoles: [
      ROLES.businessAdmin,
      ROLES.hiringManager
    ]
  },
  children: [
    {
      path: '',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: 'search',
      component: SearchBase,
      children: [
        {
          path: '',
          name: 'Search',
          component: Search,
          props: true
        },
        {
          path: 'results',
          name: 'Search Results',
          component: SearchResults,
          props: true
        }
      ]
    },
    {
      path: 'favorites',
      name: 'Favorites',
      component: Favorites,
      meta: {
        root: '/admin'
      }
    },
    {
      path: 'job-stats',
      name: 'Job Stats',
      component: JobStats,
      meta: {
        root: '/admin'
      }
    },
    {
      path: 'courses',
      name: 'Courses',
      component: Courses,
      meta: {
        root: '/admin'
      }
    },
    {
      path: 'users',
      name: 'Users',
      component: Users,
      meta: {
        root: '/admin'
      }
    },
    {
      path: 'assessments',
      name: 'Assessments',
      component: Assessments,
      meta: {
        root: '/admin'
      }
    },
    {
      path: 'reports',
      name: 'Reports',
      component: Reports,
      meta: {
        root: '/admin'
      }
    },
  ]
} as RouteConfig
